import React, { useEffect, useState } from "react";
import { Dropdown, Icon } from "semantic-ui-react";
import { getApiClient } from "../../server/get_api_client";
import styled from "styled-components";
import { useScreenWidth } from "../../helper/screentWidth";

function Specialty({
  Title = "Fellowship",
  Active = true,
  value,
  onChange,
  type,
  firstmeeting = false,
}) {
  const [data, setData] = useState([]);
  const [name, setName] = useState("");
  const screenWidth = useScreenWidth();

  useEffect(() => {
    getApiClient()
      .getSpecialties()
      .then((res) => {
        if (res.data) {
          const options = res.data.map((item) => ({
            key: item.hip_specialtynewid,
            value: item.hip_specialtynewid,
            text: item.hip_name,
          }));
          setData(options);
        }
      })
      .catch((error) => console.error("API Error:", error));
  }, []);

  useEffect(() => {
    if (data.length > 0) {
      const selectedOption = data.find((data) => data.value === value);
      if (selectedOption) {
        setName(selectedOption.text);
      } else {
        setName("");
      }
    } else {
      setName("");
    }
  }, [value, data]);

  // Called when dropdown selection changes
  const handleChange = (event, data) => {
    onChange(data.value);

    const selectedOption = data.options.find(
      (option) => option.value === data.value
    );
    if (selectedOption) {
      setName(selectedOption.text);
    }
  };

  return (
    <Container firstmeeting={firstmeeting}>
      <FieldName firstmeeting={firstmeeting}>{Title}</FieldName>
      {(Active && screenWidth >= 690) || screenWidth <= 690 ? (
        <DropdownWrapper>
          <CustomDropDown
            placeholder="Select Specialty"
            fluid
            search
            selection
            disabled={!Active}
            onChange={handleChange}
            value={value}
            options={data}
          />
          <SearchIcon name="search" />
        </DropdownWrapper>
      ) : (
        <Text>{value ? name : "Empty"}</Text>
      )}
    </Container>
  );
}

// Styled components
const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr ;
  align-items: center;
  width: 100%;
  @media screen and (max-width: ${props => props.firstmeeting ? "983px" : "690px"}) {
    grid-template-columns: 1fr;
    gap: 10px;
    max-height: 100px;
  }
`;


const FieldName = styled.div`
  text-align: right;
    justify-self: start;
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 14px;
  font-style: italic;
  font-weight: 300;
  @media screen and (max-width: ${(props) =>
      props.firstmeeting ? "983px" : "690px"}) {
    padding: 20px 0px 0px 0px;
  }
`;


const Text = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  border-radius: 5px;
  min-width: 120px;
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  font-weight: 600;
  line-height: 30px;

  height: 36px;
`;
const CustomDropDown = styled(Dropdown)`
  background: var(--editable) !important;
  border: none !important;

  .dropdown.icon {
    display: none !important;
  }
&.ui.selection.dropdown {
    min-height: 30px !important;
    border-radius: 20px !important;
    padding: 0 35px 0 10px !important; /* Match padding-left: 10px */
    line-height: 30px !important;
    
    color: #304961 !important;
    font-family: "Museo Sans Cyrl" !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    border: none !important;
    outline: none !important;
  }
  
`;

const DropdownWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const SearchIcon = styled(Icon)`
  position: absolute !important;
  right: 10px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  color: #304961 !important;
  pointer-events: none !important;
`;

export default Specialty;
